<template>
    <el-col :span="24" id='budgetsImport' class='p-3'>
        <el-row>
            <el-col :span="22">
                <h2 style="font-weight: 100; display: inline-block;" class="title mb-4">Welcome!</h2>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="22" v-html="homePageData"></el-col>
        </el-row>
    </el-col>
</template>

<script>
  export default {
    name: 'home',
    data () {
      return {
        homePageData: ''
      }
    },
    methods: {
      async reloadComponent () {
        this.$forceUpdate()
      }
    },
    mounted () {
      this.homePageData = this.$store.getters.getUiSettings['HOME_PAGE']
      this.$root.$on('reloadHomeData', async () => await this.reloadComponent())  // Reload data when instance changes
    }
  }
</script>

<style>
.title{
    color: rgb(67 67 135) !important;;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue